import * as Yup from 'yup';

export const billSchema = (disabledStakeholder = false) => Yup.object().shape({
  stakeholder: Yup.object().when({
    is: () => !disabledStakeholder,
    then: Yup.object()
      .required('Campo Obrigatório').nullable(),
    otherwise: Yup.object().notRequired().nullable(),
  }),
  value: Yup.number().required('Campo obrigatório'),
  qtyParts: Yup.number().required('Campo obrigatório'),
  parts: Yup.array(Yup.object({
    expirationDate: Yup.mixed().when('pay', {
      is: (pay) => pay,
      then: Yup.string()
        .required('Campo Obrigatório')
        .typeError('A data deve ter o formato dd/mm/yyyy'),
      otherwise: Yup.mixed().notRequired(),
    }),
    paymentDate: Yup.mixed().when('pay', {
      is: (pay) => pay,
      then: Yup.string()
        .required('Campo Obrigatório')
        .typeError('A data deve ter o formato dd/mm/yyyy'),
      otherwise: Yup.mixed().notRequired(),
    }),
    paymentType: Yup.number().required('Campo Obrigatório'),
    bankAccount: Yup.mixed().required('Campo Obrigatório'),
  })),
});
